import { withSentryReactRouterV7Routing } from "@sentry/react";
import { Routes, Route } from "react-router";
import { useState } from "react";
import { ChooseTheme } from "./components/choose_theme";
import { StatementSurveyWrapper } from "./components/statement";
import { Footer } from "./components/footer";
import { PrivacyCard } from "./components/privacy_card";
import { apiClient } from "./client";
import translate from "./locales";
import topLeftImg from "./assets/images/top_left.png";
import logoImg from "./assets/images/smart_logo.png";
import topRightImg from "./assets/images/top_right.png";
import bottomLeftImg from "./assets/images/bottom_left.png";
import bottomRightImg from "./assets/images/bottom_right.png";

const SentryRoutes = withSentryReactRouterV7Routing(Routes);

document.title = translate("page_title");

export default function App() {
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <>
      <header className="app-header">
        <img src={topLeftImg} alt="" className="app-header__corner" />
        <img src={logoImg} alt="Smart logo" className="app-header__logo" />
        <img src={topRightImg} alt="" className="app-header__corner" />
      </header>
      {showPrivacy ? (
        <PrivacyCard onClose={() => setShowPrivacy(false)} />
      ) : (
        <SentryRoutes>
          <Route path="/" element={<ChooseTheme />} />
          <Route
            path="/:statement"
            element={<StatementSurveyWrapper apiClient={apiClient} />}
          />
        </SentryRoutes>
      )}
      <Footer
        bottomLeftImg={bottomLeftImg}
        bottomRightImg={bottomRightImg}
        onPrivacyClick={() => setShowPrivacy(true)}
      />
    </>
  );
}
